import actions from "./actions";

const {
    FETCH_IT_COMPONENT, FETCH_IT_COMPONENTS, RESET_IT_COMPONENT, RESET_IT_COMPONENTS,
    FETCH_IP_ADDRESSES, RESET_IP_ADDRESSES
} = actions;

const initState = {
    itComponents: {
        // page: 0,
        // perPage: 35,
        data: [],
        // total: 0
    },
    itComponent: {_id: null},
    ipAddresses: {
        page: 0,
        // perPage: 35,
        data: [],
        // total: 0
    }
};

const ITComponentReducer = (state = initState, action) => {
    const {type, data} = action;
    switch (type) {
        case FETCH_IT_COMPONENTS:
            return {
                ...state,
                itComponents: data
            }
        case RESET_IT_COMPONENT:
            return {
                ...state,
                itComponent: initState.itComponent,
            };
        case RESET_IT_COMPONENTS:
            return {
                ...state,
                itComponents: initState.itComponents,
            };
        case FETCH_IT_COMPONENT:
            return {
                ...state,
                itComponent: data,
            };
        case FETCH_IP_ADDRESSES:
            return {
                ...state,
                ipAddresses: data
            }
        case RESET_IP_ADDRESSES:
            return {
                ...state,
                ipAddresses: initState.ipAddresses,
            };
        default:
            return state;
    }
}

export default ITComponentReducer;
